__turbopack_context__.v({
  "content": "swipe-module__PqoQ_G__content" + " " + __turbopack_context__.i(82045)["page"],
  "current": "swipe-module__PqoQ_G__current",
  "menu": "swipe-module__PqoQ_G__menu",
  "menuItem": "swipe-module__PqoQ_G__menuItem",
  "pageCenter": "swipe-module__PqoQ_G__pageCenter",
  "pageLeft": "swipe-module__PqoQ_G__pageLeft",
  "pageRight": "swipe-module__PqoQ_G__pageRight",
  "swipeWrapper": "swipe-module__PqoQ_G__swipeWrapper",
  "wrapper": "swipe-module__PqoQ_G__wrapper",
});
